// extracted by mini-css-extract-plugin
export default {"card":"List_card__Vc0Ha","container":"List_container__RAxQ7","cardContainer":"List_cardContainer__e-2PB"};